// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tutorial-control {
  height: 100vh;
  width: 100%;
}
.tutorial-control p {
  font-size: 1.8vh;
}
.tutorial-control .close-btn {
  position: absolute;
  top: calc(var(--ion-safe-area-top) + 10px);
  right: 15px;
  padding: 10px;
  z-index: 2;
}
.tutorial-control .swiper-wrapper {
  height: 100vh;
  width: 100%;
}
.tutorial-control .swiper-wrapper .swiper-slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px;
}
.tutorial-control .swiper-wrapper .swiper-slide ion-grid {
  width: 100%;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action {
  height: 70%;
  align-items: center;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action img.example-control {
  max-width: 35vh;
  border-radius: 10px;
  margin: 3vh 0;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .arrows {
  display: grid;
  grid-template-columns: repeat(3, 80px);
  grid-template-rows: repeat(3, 80px);
  justify-content: center;
  align-items: center;
  grid-gap: 3vw;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .arrows .arrow-up {
  transform: rotate(270deg);
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .arrows .arrow-left {
  transform: rotate(180deg);
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .arrows .arrow-right {
  transform: rotate(0deg);
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .arrows .arrow-down {
  transform: rotate(90deg);
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .arrows span {
  position: absolute;
  top: 43px;
  right: 30px;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .rotation {
  display: grid;
  grid-template-columns: repeat(2, 110px);
  grid-template-rows: repeat(3, 110px);
  justify-content: center;
  grid-gap: 15px;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .rotation .rotation-action {
  background-color: rgb(33, 33, 33);
  border-radius: 15px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: small;
  gap: 10px;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action .rotation .rotation-action span {
  margin-bottom: 5px;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-action #target-point {
  height: 100px;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-description {
  height: 13%;
  width: 83%;
  display: flex;
  margin: auto;
  color: #aeaeae;
}
.tutorial-control .swiper-wrapper .swiper-slide .row-button {
  height: 9%;
  align-items: center;
}
.tutorial-control .swiper-pagination {
  bottom: 35px;
  --swiper-pagination-color: white;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-color: white;
  --swiper-pagination-bullet-inactive-opacity: 0.3;
  --swiper-pagination-bullet-inactive-color: white;
  --swiper-pagination-bullet-width: 8px;
  --swiper-pagination-bullet-height: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/avatar/modals/tutorial-control/tutorial-control.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AAAJ;AAGE;EACE,aAAA;EACA,WAAA;AADJ;AAGI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AADN;AAGM;EACE,WAAA;AADR;AAIM;EACE,WAAA;EACA,mBAAA;AAFR;AAIQ;EACE,eAAA;EACA,mBAAA;EACA,aAAA;AAFV;AAKQ;EACE,aAAA;EACA,sCAAA;EACA,mCAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAHV;AAKU;EACE,yBAAA;AAHZ;AAMU;EACE,yBAAA;AAJZ;AAOU;EACE,uBAAA;AALZ;AAQU;EACE,wBAAA;AANZ;AASU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAPZ;AAWQ;EACE,aAAA;EACA,uCAAA;EACA,oCAAA;EACA,uBAAA;EACA,cAAA;AATV;AAWU;EAKE,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AAbZ;AACY;EACE,kBAAA;AACd;AAcQ;EACE,aAAA;AAZV;AAgBM;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;AAdR;AAiBM;EACE,UAAA;EACA,mBAAA;AAfR;AAoBE;EACE,YAAA;EACA,gCAAA;EACA,qCAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,qCAAA;EACA,sCAAA;AAlBJ","sourcesContent":[".tutorial-control {\n  height: 100vh;\n  width: 100%;\n\n  p {\n    font-size: 1.8vh;\n  }\n\n  .close-btn {\n    position: absolute;\n    top: calc(var(--ion-safe-area-top) + 10px);\n    right: 15px;\n    padding: 10px;\n    z-index: 2;\n  }\n\n  .swiper-wrapper {\n    height: 100vh;\n    width: 100%;\n\n    .swiper-slide {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      padding: 10px;\n\n      ion-grid {\n        width: 100%;\n      }\n\n      .row-action {\n        height: 70%;\n        align-items: center;\n\n        img.example-control {\n          max-width: 35vh;\n          border-radius: 10px;\n          margin: 3vh 0;\n        }\n\n        .arrows {\n          display: grid;\n          grid-template-columns: repeat(3, 80px);\n          grid-template-rows: repeat(3, 80px);\n          justify-content: center;\n          align-items: center;\n          grid-gap: 3vw;\n\n          .arrow-up {\n            transform: rotate(270deg);\n          }\n\n          .arrow-left {\n            transform: rotate(180deg);\n          }\n\n          .arrow-right {\n            transform: rotate(0deg);\n          }\n\n          .arrow-down {\n            transform: rotate(90deg);\n          }\n\n          span {\n            position: absolute;\n            top: 43px;\n            right: 30px;\n          }\n        }\n\n        .rotation {\n          display: grid;\n          grid-template-columns: repeat(2, 110px);\n          grid-template-rows: repeat(3, 110px);\n          justify-content: center;\n          grid-gap: 15px;\n\n          .rotation-action {\n            span {\n              margin-bottom: 5px;\n            }\n\n            background-color: rgb(33, 33, 33);\n            border-radius: 15px;\n            padding: 10px;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            font-size: small;\n            gap: 10px;\n          }\n        }\n\n        #target-point {\n          height: 100px;\n        }\n      }\n\n      .row-description {\n        height: 13%;\n        width: 83%;\n        display: flex;\n        margin: auto;\n        color: #aeaeae;\n      }\n\n      .row-button {\n        height: 9%;\n        align-items: center;\n      }\n    }\n  }\n\n  .swiper-pagination {\n    bottom: 35px;\n    --swiper-pagination-color: white;\n    --swiper-pagination-bullet-opacity: 1;\n    --swiper-pagination-bullet-color: white;\n    --swiper-pagination-bullet-inactive-opacity: 0.3;\n    --swiper-pagination-bullet-inactive-color: white;\n    --swiper-pagination-bullet-width: 8px;\n    --swiper-pagination-bullet-height: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
